import { Injectable } from '@angular/core';
import { Anlagentyp } from '../../domain/model/anlagentyp';

@Injectable({
    providedIn: 'root',
})
export class AnlagentypColorService {

    public static readonly DEFAULT_COLOR = 'iridescent-indigo-muted';
    public static readonly COLOR_OTHERTYPES = 'pulsing-purple-dark';
    public static readonly COLOR_WATER = 'iridescent-indigo-dark';
    public static readonly COLOR_WIND = 'blazing-blue-dark';
    public static readonly COLOR_BHKW = 'radiant-red-dark';
    public static readonly COLOR_PHOTOVOLTAIC = 'galvanic-green-muted';
    public static readonly COLOR_BIO = 'galvanic-green-dark';

    public static readonly ABKUERZUNG_TO_COLOR_NAME = {
        // other types
        'sonst': AnlagentypColorService.COLOR_OTHERTYPES,

        // water
        'was': AnlagentypColorService.COLOR_WATER,

        // bio and geo
        'grub': AnlagentypColorService.COLOR_BIO,
        'bio': AnlagentypColorService.COLOR_BIO,
        'depog': AnlagentypColorService.COLOR_BIO,
        'geoth': AnlagentypColorService.COLOR_BIO,
        'klaer': AnlagentypColorService.COLOR_BIO,

        // wind
        'wind': AnlagentypColorService.COLOR_WIND,

        // bhkw / ikw
        'kwk-g': AnlagentypColorService.COLOR_BHKW,

        // Photovoltaic
        'pvk': AnlagentypColorService.COLOR_PHOTOVOLTAIC,
        'pv': AnlagentypColorService.COLOR_PHOTOVOLTAIC,
    };

    public getColorNameForAnlagentyp(anlagentyp: Anlagentyp): string {
        if (anlagentyp && anlagentyp.abkuerzung) {
            const abkuerzungLower = anlagentyp.abkuerzung.toLocaleLowerCase();
            const colorName = AnlagentypColorService.ABKUERZUNG_TO_COLOR_NAME[abkuerzungLower];
            if (colorName) {
                return colorName;
            }
        }
        return AnlagentypColorService.DEFAULT_COLOR;
    }

}
